/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let lbilChatAPiUrl = root.userChatListUrl.link;

export default {
  state: {
    getLbilChatUserListState:{}
  },
  mutations: {
    getLbilChatUserListMutation(state, value) {
      Vue.set(state, 'getLbilChatUserListState', value);
    }
  },
  actions: {
    // Get Lbil Chat User List Action Method
    getLbilChatUserListAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(lbilChatAPiUrl + '?platform_type=lbil').then(res => {
              context.commit('getLbilChatUserListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    }
  },
  getters: {
    getLbilChatUserListGetter: state => state.getLbilChatUserListState
  }
}